function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 25,
  fill: "#E48C34"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.0196 35H31.9804C33.0912 35 34 34.0932 34 32.9849V18.9043C34 17.796 33.0912 16.8892 31.9804 16.8892H29.8093V16.0076C29.8093 15.4534 29.3548 15 28.7994 15C28.244 15 27.7896 15.4534 27.7896 16.0076V16.8892H22.2104V16.0076C22.2104 15.4534 21.756 15 21.2006 15C20.6452 15 20.1907 15.4534 20.1907 16.0076V16.8892H18.0196C16.9088 16.8892 16 17.796 16 18.9043V32.9597C16 34.0932 16.9088 35 18.0196 35ZM18.0196 32.9849V24.471H31.9804V32.9597H18.0196V32.9849ZM20.1907 18.9043V20.2897C20.1907 20.8438 20.6452 21.2972 21.2006 21.2972C21.756 21.2972 22.2104 20.8438 22.2104 20.2897V18.9043H27.8149V20.2897C27.8149 20.8438 28.2693 21.2972 28.8247 21.2972C29.3801 21.2972 29.8345 20.8438 29.8345 20.2897V18.9043H32.0056V22.4559H18.0196V18.9043H20.1907Z",
  fill: "white"
});

var SvgGeneralAge = function SvgGeneralAge(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGeneralAge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/general_age.de220f6f.svg";
export { ForwardRef as ReactComponent };